"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnStateChangeBase = void 0;
const Entities_1 = require("../../Entities");
class OnStateChangeBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (castPayload.stateObject === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    castPayloadV2(payload) {
        const castPayload = payload;
        if (castPayload.stateObject === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 2, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'ON_STATE_CHANGE';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { stateObject } = this.castPayloadV1(payload);
                this.action(stateObject);
            }
            else if (version === 2) {
                const { stateObject, validationErrorMessage } = this.castPayloadV2(payload);
                this.action(stateObject, validationErrorMessage);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.OnStateChangeBase = OnStateChangeBase;
